
<ng-container *ngIf="product">
   <button mat-fab (click)="addToCartProduct(product)"><i  class="material-icons"> shopping_cart </i></button>
</ng-container>
